import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { useState } from "react";
import { useStyles } from "./glossaryTable.styles";

export const GlossaryTable = ({ filters, glossaryItems, isFetching }) => {
  const itemsPerView = 50;
  const [next, setNext] = useState(itemsPerView);
  const classes = useStyles();

  const noItemsAvailableMessage = () => {
    const hasKeywordFilter = filters?.[0].value;
    const hasCategoryFilter =
      filters?.[1].value === 0 ? true : filters?.[1].value;
    if (hasKeywordFilter || hasCategoryFilter) {
      return "No items were found with that filter criteria";
    }
    return "No Glossary items available";
  };

  const handleMoreItems = () => {
    setNext(next + itemsPerView);
  };

  const glossaryItem = (row) => {
    return (
      <ListItem key={row.title}>
        <ListItemText>
          <Accordion square className={classes.accordionItems}>
            <AccordionSummary
              expandIcon={<ExpandMore className={classes.accordionIcon} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.accordionItem}
            >
              <Typography className={classes.accordionTitle}>
                {row.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.typographyNewUser}>
                {row.description}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </ListItemText>
      </ListItem>
    );
  };

  const glossaryListContent = () => {
    if (isFetching && !glossaryItems.length) {
      return (
        <div className={classes.root}>
          <LinearProgress color="secondary" />
        </div>
      );
    }

    if (glossaryItems.length) {
      return (
        <Paper>
          <List className={classes.container}>
            {glossaryItems.slice(0, next).map((row) => {
              return glossaryItem(row);
            })}
          </List>
          {next <= glossaryItems.length && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleMoreItems}
              className={classes.buttonLoad}
            >
              Load more
            </Button>
          )}
        </Paper>
      );
    }

    return (
      <Grid item xs={12}>
        <Typography align="center" variant="h6">
          {noItemsAvailableMessage()}
        </Typography>
      </Grid>
    );
  };

  return (
    <Grid item xs={12}>
      {glossaryListContent()}
    </Grid>
  );
};
